
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/search/[[...urlParts]]",
      function () {
        return require("private-next-pages/[lang]/search/[[...urlParts]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/search/[[...urlParts]]"])
      });
    }
  